const sentry = require("@sentry/vue");

function normaliseForGrouping(message) {
    return String(message)
        .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '<uuid>')
        .replace(/https?:\/\/\S+/g, '<url>')
        .replace(/\d{3,}/g, '<n>');
}

export default {
    log: function (message) {
        console.log(message);
    },

    message: function (message) {
        console.log(message);
        sentry.captureMessage(message);
    },

    error: function (error, message) {
        let errObject = error;
        let errorMessage = '';

        if (error instanceof Error) {
            errorMessage = error.message;
        } else if (typeof error === 'object' && error !== null) {
            errorMessage = error.errorMsg || error.message || JSON.stringify(error);
            errObject = new Error(errorMessage);
            // Copy properties from original object to the new Error object for Sentry
            Object.keys(error).forEach(key => {
                if (!errObject[key]) {
                    errObject[key] = error[key];
                }
            });
        } else {
            errorMessage = String(error);
            errObject = new Error(errorMessage);
        }

        const fullMessage = (message ? message.substring(0, 150) + ' | ' : '') + errorMessage;

        try {
            errObject.message = fullMessage;
        }
        catch {
            // If message has no setter
        }

        // Filter out specific errors from Sentry
        const ignoreRegex = /Krisp error fetching|Failed to fetch|Error when starting local audio level observer|toCameraError is not a function|Meeting has ended|Timed out \(>20000 ms\) when loading call object bundle|Request aborted|bad sigauthz token|meeting you.re trying to join does not exist|Unable to set up call/i;
        const shouldIgnore = typeof fullMessage === 'string' && ignoreRegex.test(fullMessage);

        if (!shouldIgnore) {
            // Every error is created in this file, so without a fingerprint Sentry groups them all
            // into one issue. Group by message instead, ignoring the IDs and URLs that vary per call.
            sentry.captureException(errObject, {
                fingerprint: ['portal-logger', normaliseForGrouping(fullMessage)],
                extra: { context: message }
            });
        }

        console.log(errObject);
    }
}